import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

interface DialogData {

}

@Component({
  selector: 'app-new-print-process',
  templateUrl: './new-print-process.component.html',
  styleUrls: ['./new-print-process.component.scss']
})
export class NewPrintProcessComponent implements OnInit {

  newPrintProcessForm: FormGroup;
  isPrintProcessAdded = false;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogref: MatDialogRef<NewPrintProcessComponent>,
    private toastr: ToastrService
  ) { }

  ngOnInit() {

    this.newPrintProcessForm = this.fb.group({
      'new_print_process_name': ["", [Validators.required, Validators.minLength(3)]],
    });

  }

  cancel() {
    this.dialogref.close();
  }

  submit() {
    if (this.newPrintProcessForm.valid) {
      this.dialogref.close({ data: this.newPrintProcessForm.value })
    }
    else {
      return this.toastr.error('Please Enter a Valid Print Process that you carry out', 'Error');
    }

  }

}
